import type { CSSProperties } from 'react';

const REGEX_HEIGHT = /h-\[(\d+px)\]/;
const REGEX_WIDTH = /w-\[(\d+px)\]/;

const extractDividerThicknessFromClassName = (
  orientation: 'horizontal' | 'vertical',
  className?: string,
): string | null => {
  if (!className) {
    return null;
  }
  const match = className.match(orientation === 'horizontal' ? REGEX_HEIGHT : REGEX_WIDTH);

  return match ? match[1] : null;
};

export const dashedOrDottedDividerStyles = (
  className?: string,
  style?: CSSProperties,
  orientation: 'horizontal' | 'vertical' = 'horizontal',
  dividerType: 'dotted' | 'dashed' | 'solid' = 'solid',
) => {
  if (dividerType === 'solid') {
    return {};
  }
  let thickness = extractDividerThicknessFromClassName(orientation, className);
  if (!thickness) {
    thickness = orientation === 'horizontal' ? (style?.height as string) : (style?.width as string);
  }

  const dashedBorderStyle = {
    borderTop:
      orientation === 'horizontal'
        ? `${thickness ?? ''} ${dividerType} var(--Divider-lineColor)`
        : 'none',
    borderLeft:
      orientation === 'vertical'
        ? `${thickness ?? ''} ${dividerType} var(--Divider-lineColor)`
        : 'none',
    backgroundColor: 'transparent',
  };
  return dashedBorderStyle;
};
